export const Location = 'Location';

export const New = 'New';

export const TodayTotalSale = 'Today Total sale';

export const Name = 'Name';

export const ContactUs = 'Contact Us';
export const Email = 'Email';

export const Phone = 'Phone';
export const EmailAddress = 'Email Address';

export const Password = 'Password';
export const LogOut = 'Log Out';

export const Pagi_Nations = 'Pagination';
export const PaginationWithIcons = 'Pagination with icons';
export const PaginationAlignment = 'Pagination alignment';
export const PaginationActiveDisabled = 'Pagination with active and disabled';
export const PaginationColor = 'Pagination Color';
export const PaginationSizing = 'Pagination sizing';
export const Previous = 'Previous';
export const Next = 'Next';

// pages
export const RememberPassword = 'Remember password';
export const ForgotPassword = 'Forgot password?';
export const CreateAccount = 'Create Account';
export const AUTH0 = 'AUTH0';
export const JWT = 'JWT';
export const LoginWithJWT = 'Login';

// layout
export const Loading = 'Loading...';

export const Admin = 'Admin';
export const Account = 'Account';

export const TIME_ZONE = '-0530';

export const IMAGE_URL = 'https://mcode.fra1.digitaloceanspaces.com/byte-nfc/bytenfc.png';

export const DATA_NOT_FOUND =
  'https://img.freepik.com/free-vector/no-data-concept-illustration_114360-536.jpg?w=900&t=st=1667466035~exp=1667466635~hmac=fb00d8e365338a2998c49c4661d0abb17de576ce3efd265331b8a98d6877bc5b';

export const ENDPOINT_IMAGE = '/byte-nfc/bytenfc.png';

export const PRODUCT_IMAHE =
  'data:image/jpeg;base64,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';
// <<<<<<<<<<<<<<<--------------USER ROLE WISE ACCESS------------------->>>>>>>>>>>>>

export const USER_ROLE = {
  ADMIN: 1,
  SELLER: 2
};

export const CLIENT_TYPE = {
  USER: 2,
  BANK: 3,
  ORGANIZATION: 1,
  PERSONE: 4,
  PUBLIC_FORM: 5,
  BILL: 6
};

export const ORDER_STATUS = {
  PENDING: 1,
  COMPLETE: 2
};

export const ORDER_TYPE = {
  BUY: 1,
  SELL: 2
};

export const Role = [
  {
    id: 1,
    name: 'super admin'
  },
  {
    id: 2,
    name: 'organization admin'
  }
];

export const RoleAccess = {
  SUPPER_ADMIN: 1,
  ORG_ADMIN: 2,
  TEMPLE_ADMIN: 3,
  CASHIER: 4,
  ACCOUNTANT: 5,
  EVENT_COORDINATOR: 6
};

export const OPTION = [
  {
    value: 1,
    name: 'READ'
  },
  {
    value: 2,
    name: 'WRITE'
  },
  {
    value: 3,
    name: 'UPDATE'
  },
  {
    value: 4,
    name: 'DELETE'
  },
  {
    value: 5,
    name: 'DOWNLOAD'
  }
];

export const PRIVILLAGE_OPTIONS = [
  {
    value: 'GET',
    name: 'GET'
  },
  {
    value: 'POST',
    name: 'POST'
  },
  {
    value: 'PUT',
    name: 'PUT'
  },
  {
    value: 'DELETE',
    name: 'DELETE'
  }
];

/**
 * bank master constant
 */

export const BANK_MASTER = {
  ADD_BANK_MASTER: 'Add Bank Master',
  EDIT_BANK_MASTER: 'Edit Bank Master',
  BANK_MASTER_DETAILS: 'Bank Master Details',
  BANK_MASTER_PERENT: 'Bank Master',
  VIWE_BANK_MASTER: 'View Bank Master',
  STATEMENT: 'SateMent'
};
/**
 * BILL MANAGEMENT constant
 */

export const BILL_MANAGEMENT_CONST = {
  PAYMENT_LIST: 'Payment List',
  ADD_PAYMENT: 'Add Payment',
  EDIT_PAYMENT: 'Edit Payment',
  ADD_BILL: 'Add Bill',
  EDIT_BILL: 'Edit Bill',
  ADD_BILL_MANAGEMENT: 'Add Vendor (Shop/Person)',
  EDIT_VENDER_BILL: 'Edit Vender Bill',
  ADD_VENDER_BILL: 'Add Vender Bill',
  EDIT_BILL_MANAGEMENT: 'Edit Bill Management',
  BILL_MANAGEMENT_DETAILS: 'Bill Management Details',
  BILL_MANAGEMENT_PERENT: 'Bill Management',
  VIWE_BILL_MANAGEMENT: 'View Bill Management',
  STATEMENT: 'SateMent'
};

/**
 * Temple master constant
 */

export const TEMPLE_MASTER = {
  ADD_TEMPLE_MASTER: 'Add Temple Master',
  EDIT_TEMPLE_MASTER: 'Edit Temple Master',
  TEMPLE_MASTER_DETAILS: 'Temple Master Details',
  TEMPLE_MASTER_PERENT: 'Temple Master',
  TEMPLE_MASTER_MASTER: 'View Temple Master',
  STATEMENT: 'SateMent'
};

/**
 * User master constant
 */

export const USER_MASTER = {
  ADD_USER_MASTER: 'Add User',
  EDIT_USER_MASTER: 'Edit User',
  USER_MASTER_DETAILS: 'User Details',
  USER_MASTER_PARENT: 'Users',
  VIEW_USER_MASTER: 'View User',
  STATEMENT: 'SateMent'
};

/**
 * Temple Trust
 */

export const TEMPLE_TRUST = {
  ADD_TEMPL_TRUST_: 'Add Temple Trust ',
  EDI_TRUST_TEMPL_TRUST_: 'Edit Temple Trust ',
  TEMPL_TRUST_DETAILS: 'Temple  Details Trust',
  TEMPL_TRUST_PERENT: 'Temple Trust',
  TEMPL_TRUST_VIEW: 'View Temple Trust',
  STATEMENT: 'SateMent'
};

/**
 * Donation Constant
 */

export const DONATION = {
  ADD_DONATION: 'Add Donation',
  ADD_EXPANSE: 'Add Expanse',
  EDIT_DONATION: 'Edit Donation',
  EDIT_EXPANSE: 'Edit Expanse',
  DONATION_DETAILS: 'Donation Details',
  DONATION_PERENT: 'Donation',
  EXPANCE_PERENT: 'Expance',
  VIWE_DONATION: 'View Donation',
  STATEMENT: 'SateMent'
};

/**
 * Donation Add
 */

export const DONATION_ADD = {
  CONTACT_NO: 'Contact No*',
  RELATIVE_NO: 'Relative No',
  NAME: 'Name*',
  VILLAGE: 'Village',
  PANCARD: 'Pancard',
  AADHAAR_CARD: 'Aadhaarcard',
  BY_HAND: 'By Hand (હસ્તે)',
  DOB: 'DOB',
  DOD: 'DOD (તિથિ)',
  CITY: 'City',
  STATE: 'State',
  COUNTRY: 'Country',
  ADDRESS: 'Address',
  DONTION_TYPE: 'Donation Type',
  AMOUNT: 'Amount',
  PAYMENT_MODE: 'Payment Mode',
  PAYMENT_TYPE: 'Payment Type',
  TOTAL_AMOUNT: 'Total Amount',
  TRANSECTION_NO: 'Transaction No.',
  NOTE: 'Note'
};

/**
 * Donation Master Constant
 */

export const TITLE = {
  CONFIRMATION: 'Confirmation'
};

export const DONATION_MASTER = {
  ADD_DONATION_MASTER: 'Add Donation Master',
  EDIT_DONATION_MASTER: 'Edit Donation Master',
  DONATION_MASTER_DETAILS: 'Donation Master Details',
  VIEW_DONATION_MASTER: 'View Donation Master',
  DONATION_MASTER_PARENT: 'Donation Master'
};

/**
 * Donar constant
 */

export const DONAR = {
  ADD_DONAR: 'Add Donar',
  EDIT_DONAR: 'Edit Donar',
  DONAR_DETAILS: 'Donar Details',
  VIEW_DONER: 'View Donar',
  DONAR_PARENT: 'Donar'
};

/**
 * Donation Constant
 */

export const INCOME = {
  ADD_INCOME: 'Add Income',
  EDIT_INCOME: 'Edit Income',
  PAY_NOW: 'Paynow',
  INCOME_DETAILS: 'Income Details',
  VIEW_INCOME: 'View Income',
  INCOME_PARENT: 'Income'
};
export const DONATION_FEILD = {
  DONAR: 'Donar',
  DONATION: 'Income Type',
  AMOUNT: 'Amount',
  DUE_AMOUNT: 'Due Amount',
  PAID_AMOUNT: 'Paid Amount',
  BANK: 'Bank',
  PAYMENTMODE: 'Payment Mode',
  NOTE: 'Note',
  NAME: 'Name',
  TYPE: 'Type',
  SLIP_NO: 'Slip No.',
  CREDIT: 'Credit',
  DEBIT: 'Debit',
  TRUST: 'Trust'
};

/**
 * Expnace Constant
 */

export const EXPANCE = {
  ADD_EXPANCE: 'Add Expase',
  EDIT_EXPANCE: 'Edit Expanse',
  EXPANCE_DETAILS: 'Expanse Details',
  VIEW_EXPANCE: 'View Expanse',
  EXPANCE_PARENT: 'Expanse'
};

export const EXPANCE_FEILD = {
  DONAR: 'Donar',
  EXPANCE: 'Expanse Type',
  AMOUNT: 'Amount',
  DUE_AMOUNT: 'Due Amount',
  PAID_AMOUNT: 'Paid Amount',
  BANK: 'Bank',
  NOTE: 'Note',
  NAME: 'Name',
  DONATION: 'Donation',
  TYPE: 'Type',
  SLIP_NO: 'Slip No.',
  CREDIT: 'Credit',
  DEBIT: 'Debit',
  TRUST: 'Trust'
};

/**
 * Suppliar Constant
 */

export const SUPPLIAR = {
  ADD_SUPPLIAR: 'Add Suppliar',
  EDIT_SUPPLIAR: 'Edit Suppliar',
  SUPPLIAR_DETAILS: 'Suplliar Details',
  VIEW_SUPLLIAR: 'View Suppliar',
  SUPPLIAR_PERENT: 'Suppliar'
};

/**
 * Notes Constant
 */
export const NOTES = {
  ADD_NOTES: 'Add Notes',
  EDIT_NOTES: 'Edit Notes',
  NOTES_DETAILS: 'Notes Details',
  NOTES_PERENTS: 'Notes'
};

/**
 *Donation Master Dropdown constant
 */

export const ACCOUNT_TYPE = {
  inward: 1,
  inward_name: 'Inward',
  CREDIT: 'Credit',
  DEBIT: 'Debit',
  outward: 2,
  outward_name: 'Outward'
};

/**
 * button style
 */
export const Style = {
  color: 'white',
  width: '4rem',
  height: '4rem',
  borderRadius: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center'
};

export const validation = {
  color: 'red'
};
export const validtionElse = {
  color: 'black'
};

/**
 * Validation Label
 */

export const ValidationLabel = {
  nameRequired: 'Name* (Name is Required)',
  billDate: 'Bill Date*',
  paymentDate: 'Payment Date*',
  paymentDateRequired: 'Payment Date* (Payment Date is Required)',
  amount: 'Amount*',
  amountRequired: 'Amount* (Amount is Required)',
  billRequired: 'Bill Date* (Bill Date is Required)',
  paymentMode: 'Payment Mode*',
  paymentModeRequired: 'Payment Mode* (Payment Mode is Required)',
  referenceNo: 'Reference No*',
  referenceNoRequired: 'Reference No* (Reference No is Required)',
  totalAmount: 'Bill Amount*',
  totalAmountRequired: 'Bill Amount* (Bill Amount is Required)',
  name: 'Name*',
  accountNoRequired: 'Account No.* (Account No. is Required)',
  accountNo: 'Account No.*',
  confirmAccount: 'Confirm Account No.*',
  confirmAccountRequired: 'Confirm Account No.* (is Required)',
  contactNo: 'Contact No.*',
  dialCode: 'Dial Code*',
  contactNoRequired: 'Contact No.* (is Required)',
  countryCodeRequired: 'Dial Code No.* (is Required)',
  Donar: 'Donar*',
  DonarRequired: 'Donar* (Donar is Required)',
  Donation: 'Donation*',
  DonationRequired: 'Donation* (Donation is Required)',
  Amount: 'Amount*',
  AmountRequired: 'Amount* (Amount is Required)',
  templeNameRequired: 'Temple Name* (is Required)',
  templeName: 'Temple Name*',
  password: 'Password*',
  passwordRequired: 'Password* (Password is Required)',
  passwordMaxLength: 'Password* (Password min 8 digits)',
  confirmPassword: 'Confirmpassword*',
  notMatch: 'Password no match',
  confirmPasswordRequired: 'Confirmpassword* (is Required)',
  confirmPasswordRMaxLangth: 'Confirmpassword* (min 8 digits)'
};

/**
 * Donation Master Add
 */

export const DonationAdd = {
  TRUST: 'Trust',
  TYPE: 'Type',
  NAME: 'Name'
};

/**
 * Note Add Constant
 */

export const NOTE_CONTEXT = {
  NOTE: 'Note',
  TITLE: 'Title'
};

/**
 * Organization Constant
 */

export const ORGANIZATION = {
  ADD_ORG: 'Add Organization',
  EDIT_ORG: 'Edit Organization',
  ORG_DETAILS: 'Organization Details',
  NAME: 'Name',
  ADDRESS: 'Address*',
  ADDRESS_REQUIRED: 'Address* (is Required)',
  PHONE: 'Phone*',
  PHONE_REQUIRED: 'Phone* (is Required)',
  GST_NUMBER: 'GST Number',
  PANCARD_NO: 'Pancard No.',
  EMAIL_REQUIRED: 'Email* (Email is Required)',
  EMAIL: 'Email*',
  CITY: 'City',
  STATE: 'State',
  USER_DETAILS: 'User Details',
  PASSWORD: 'Password',
  CONFIRM_PASSWORD: 'Confirmpassword'
};

/**
 * Slip Download Constant
 */

export const SLIP_DOWNLOADE = {
  CONTECT_NO: 'Contect No.',
  MOBILE: 'Mobile No.',
  EMAIL: 'Email.',
  TRUST_REG: 'Trust Reg.',
  PAN_NO: 'Pan No.',
  CERTI_NO: 'Certi No.',
  NAME: 'Name',
  RECEIPT_NO: 'Receipt No.',
  ADDRESS: 'Address',
  RECEIPT_DATE: 'Receipt Date',
  MOBILE_NO: 'Mobile No.',
  PURPOSE: 'Account',
  AMOUNT: 'Amount',
  BY_HEND: 'By Hand'
};

/**
 * Payment type dropdown
 */

export const PaymentDropDown = [
  {
    label: 'Cheque',
    value: 1
  },
  {
    label: 'DD',
    value: 2
  },
  {
    label: 'RTGS',
    value: 3
  },
  {
    label: 'NEFT',
    value: 4
  },
  {
    label: 'IMPS',
    value: 5
  },
  {
    label: 'UPI',
    value: 6
  },
  {
    label: 'Other',
    value: 8
  }
];

export const PaymentDropDownCaseOnly = [
  {
    label: 'CASH',
    value: 7
  }
];

/**
 * Bank Master Type
 */

export const BANKTYPE = [
  {
    id: 1,
    name: 'Cash'
  },
  {
    id: 2,
    name: 'Bank'
  }
];

export const PAYMENT_TYPE = [
  {
    name: 'CASH'
  },
  {
    name: 'UPI'
  }
];

export const BANK_TYPE = {
  CASE: 1,
  CASE_LABALE: 'Cash',
  BANK: 2,
  BANK_LABALE: 'Bank'
};

/**
 * Status
 */

export const PAYMENT_SLIP_STATUS = {
  PENDING: 1,
  ACCEPTED: 2
};

/**
 * image base url
 */

export const BASE_URL_IMG = process.env.REACT_APP_IMAGE_URL || 'https://bytebiz.fra1.digitaloceanspaces.com/mcode/hisab-kitab/';

/**
 * Button Name Constant
 */

export const BUTTON_NAME = {
  SUBMIT: 'Submit'
};

/**
 * Error Status Code and Error Message
 */

export const ERROR_CODE = {
  UNAUTHORIZED: 401
};

// income and expanse Analysis types
export const ANALYSIS_TYPE = {
  day: 1,
  month: 2,
  year: 3
};
export const ANALYSIS_TYPE_ARR = [
  {
    value: 1,
    name: 'Day'
  },
  { value: 2, name: 'Month' },
  { value: 3, name: 'Year' }
];

export const IxAnalysis = [RoleAccess.ORG_ADMIN, RoleAccess.TEMPLE_ADMIN, RoleAccess.CASHIER];
export const dashboardAccountMaster = [RoleAccess.ORG_ADMIN, RoleAccess.TEMPLE_ADMIN, RoleAccess.CASHIER];

export const gujaratiMonth = [
  {
    month: 'કારતક'
  },
  {
    month: 'માગશર'
  },
  {
    month: 'પોષ'
  },
  {
    month: 'મહા'
  },
  {
    month: 'ફાગણ'
  },
  {
    month: 'ચૈતર'
  },
  {
    month: 'વૈશાખ'
  },
  {
    month: 'જેઠ'
  },
  {
    month: 'અષાડ'
  },
  {
    month: 'શ્રાવણ'
  },
  {
    month: 'ભાદરવો'
  },
  {
    month: 'આસો'
  }
];

export const pakhvadiya = [{ pakhvadiya: 'વદ' }, { pakhvadiya: 'સુદ' }];

export const gujaratidate = [
  {
    gujDate: 'પડવો - 1'
  },
  {
    gujDate: 'બીજ - 2'
  },
  {
    gujDate: 'ત્રીજ - 3'
  },
  {
    gujDate: 'ચોથ - 4'
  },
  {
    gujDate: 'પાંચમ - 5'
  },
  {
    gujDate: 'છઠ્ઠ - 6'
  },
  {
    gujDate: 'સાતમ - 7'
  },
  {
    gujDate: 'આઠમ'
  },
  {
    gujDate: 'નોમ'
  },
  {
    gujDate: 'દશમ'
  },
  {
    gujDate: 'અગિયારસ'
  },

  {
    gujDate: 'બારસ'
  },

  {
    gujDate: 'તેરસ'
  },

  {
    gujDate: 'ચૌદસ'
  },

  {
    gujDate: 'પૂનમ'
  },

  {
    gujDate: 'અમાસ'
  }
];

export const OTP_EXPIRY_TIME = 120; // IN SECOUND

export const TypeFilter = {
  INCOME: 1,
  EXPANCE: 2
};

export const SOCKET_STATUS = {
  NOT_CONNECTED: 'not_connected',
  SESSION_CLOSE: 'session_closed',
  CONNECTED: 'connected',
  ERROR: 'error',
  DIS_CONNECTED: 'disconnected',
  AUTHENTICATED: 'authenticated',
  AUTH_FAILURE: 'auth_failure',
  LOADING_SCREEN: 'loading_screen',
  READY: 'ready',
  QR: 'qr'
};

export const SOCKET_EVENT = {
  CONNECT: 'connect',
  STATUS: 'status'
};

export const isWhatsAppPermission = 1;
